export const Footer = ({ className = "max-w-[1000px]" }: { className?: string }) => (
  <footer className={`w-full ${className} opacity-50 pt-5 pb-10`}>
    <div className="flex flex-col border-t pt-5 xs:flex-row xs:justify-between items-center gap-4 xs:gap-0 bg-butter-cream-light pb-4">
      <div className="flex items-center">
        <a
          href="https://joinbutter.co"
          target="_blank"
          rel="noopener noreferrer"
          className=""
        >
          <svg
            width="30"
            height="40"
            viewBox="0 0 107 120"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M21.5596 0.00164032C19.4231 0.00164032 17.82 1.42574 17.4639 3.56214L0.0168848 114.302C-0.161155 116.261 1.08379 117.863 3.04229 117.863H17.2863C19.7789 117.863 21.0259 116.439 21.382 114.302L23.1613 102.552C27.4343 75.3121 39.8963 63.5601 50.5793 63.5601C60.0155 63.5601 62.6873 72.641 60.1945 83.5011C58.058 92.9373 52.3616 102.017 43.8155 102.017C39.5425 102.017 37.4042 101.661 35.8018 101.127C33.3092 100.414 31.7073 100.772 30.9952 102.552L27.4347 110.92C26.3665 113.412 27.2561 114.837 31.173 116.439C34.0217 117.685 40.9669 120 52.896 120C71.59 120 86.01 114.303 96.871 102.552C101.144 97.7454 104.884 92.0475 106.486 85.8165C107.376 82.4337 107.019 81.1869 104.883 80.4747L97.9393 78.338C95.8028 77.8039 94.5577 78.3382 93.8455 80.4747C91.531 86.7061 89.0379 90.446 86.1893 93.4727C81.0261 98.8139 73.9043 102.731 69.2753 102.731C73.9044 100.06 82.2713 90.8005 83.3393 76.3785C84.7636 57.1505 72.1233 44.5095 55.9213 44.5095C44.1703 44.5095 35.2693 51.2763 30.4623 56.2615L38.8295 3.5605C39.1856 1.602 37.9386 0 35.8022 0L21.5596 0.00164032Z"
              fill="#4A5043"
            />
          </svg>
        </a>
        <div className="ml-4 leading-[11px]">
          <p className="text-xs font-serif">The IRL app</p>
          <p className="text-[11px] font-sans">
            Do the things you want to do. Find people who want to do them too.
          </p>
        </div>
      </div>
      <div className="flex flex-row items-center gap-4 self-start xs:self-auto">
        <a
          target="_blank"
          rel="noopener noreferrer"
          href="https://instagram.com/joinbutter"
        >
          <svg
            role="img"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            xmlns="http://www.w3.org/2000/svg"
          >
            <title>Instagram</title>
            <path
              fill="#4A5043"
              d="M7.0301.084c-1.2768.0602-2.1487.264-2.911.5634-.7888.3075-1.4575.72-2.1228 1.3877-.6652.6677-1.075 1.3368-1.3802 2.127-.2954.7638-.4956 1.6365-.552 2.914-.0564 1.2775-.0689 1.6882-.0626 4.947.0062 3.2586.0206 3.6671.0825 4.9473.061 1.2765.264 2.1482.5635 2.9107.308.7889.72 1.4573 1.388 2.1228.6679.6655 1.3365 1.0743 2.1285 1.38.7632.295 1.6361.4961 2.9134.552 1.2773.056 1.6884.069 4.9462.0627 3.2578-.0062 3.668-.0207 4.9478-.0814 1.28-.0607 2.147-.2652 2.9098-.5633.7889-.3086 1.4578-.72 2.1228-1.3881.665-.6682 1.0745-1.3378 1.3795-2.1284.2957-.7632.4966-1.636.552-2.9124.056-1.2809.0692-1.6898.063-4.948-.0063-3.2583-.021-3.6668-.0817-4.9465-.0607-1.2797-.264-2.1487-.5633-2.9117-.3084-.7889-.72-1.4568-1.3876-2.1228C21.2982 1.33 20.628.9208 19.8378.6165 19.074.321 18.2017.1197 16.9244.0645 15.6471.0093 15.236-.005 11.977.0014 8.718.0076 8.31.0215 7.0301.0839m.1402 21.6932c-1.17-.0509-1.8053-.2453-2.2287-.408-.5606-.216-.96-.4771-1.3819-.895-.422-.4178-.6811-.8186-.9-1.378-.1644-.4234-.3624-1.058-.4171-2.228-.0595-1.2645-.072-1.6442-.079-4.848-.007-3.2037.0053-3.583.0607-4.848.05-1.169.2456-1.805.408-2.2282.216-.5613.4762-.96.895-1.3816.4188-.4217.8184-.6814 1.3783-.9003.423-.1651 1.0575-.3614 2.227-.4171 1.2655-.06 1.6447-.072 4.848-.079 3.2033-.007 3.5835.005 4.8495.0608 1.169.0508 1.8053.2445 2.228.408.5608.216.96.4754 1.3816.895.4217.4194.6816.8176.9005 1.3787.1653.4217.3617 1.056.4169 2.2263.0602 1.2655.0739 1.645.0796 4.848.0058 3.203-.0055 3.5834-.061 4.848-.051 1.17-.245 1.8055-.408 2.2294-.216.5604-.4763.96-.8954 1.3814-.419.4215-.8181.6811-1.3783.9-.4224.1649-1.0577.3617-2.2262.4174-1.2656.0595-1.6448.072-4.8493.079-3.2045.007-3.5825-.006-4.848-.0608M16.953 5.5864A1.44 1.44 0 1 0 18.39 4.144a1.44 1.44 0 0 0-1.437 1.4424M5.8385 12.012c.0067 3.4032 2.7706 6.1557 6.173 6.1493 3.4026-.0065 6.157-2.7701 6.1506-6.1733-.0065-3.4032-2.771-6.1565-6.174-6.1498-3.403.0067-6.156 2.771-6.1496 6.1738M8 12.0077a4 4 0 1 1 4.008 3.9921A3.9996 3.9996 0 0 1 8 12.0077"
            />
          </svg>
        </a>
        <a
          target="_blank"
          rel="noopener noreferrer"
          href="https://www.tiktok.com/@join.butter"
        >
          <svg
            role="img"
            width="22"
            height="22"
            viewBox="0 0 24 24"
            xmlns="http://www.w3.org/2000/svg"
          >
            <title>TikTok</title>
            <path
              fill="#4A5043"
              d="M12.525.02c1.31-.02 2.61-.01 3.91-.02.08 1.53.63 3.09 1.75 4.17 1.12 1.11 2.7 1.62 4.24 1.79v4.03c-1.44-.05-2.89-.35-4.2-.97-.57-.26-1.1-.59-1.62-.93-.01 2.92.01 5.84-.02 8.75-.08 1.4-.54 2.79-1.35 3.94-1.31 1.92-3.58 3.17-5.91 3.21-1.43.08-2.86-.31-4.08-1.03-2.02-1.19-3.44-3.37-3.65-5.71-.02-.5-.03-1-.01-1.49.18-1.9 1.12-3.72 2.58-4.96 1.66-1.44 3.98-2.13 6.15-1.72.02 1.48-.04 2.96-.04 4.44-.99-.32-2.15-.23-3.02.37-.63.41-1.11 1.04-1.36 1.75-.21.51-.15 1.07-.14 1.61.24 1.64 1.82 3.02 3.5 2.87 1.12-.01 2.19-.66 2.77-1.61.19-.33.4-.67.41-1.06.1-1.79.06-3.57.07-5.36.01-4.03-.01-8.05.02-12.07z"
            />
          </svg>
        </a>
        <a
          className="block"
          target="_blank"
          rel="noopener noreferrer"
          href="http://linkedin.com/company/joinbutter"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            className="mb-1"
          >
            <path
              fill="#4A5043"
              d="M4.98 3.5c0 1.381-1.11 2.5-2.48 2.5s-2.48-1.119-2.48-2.5c0-1.38 1.11-2.5 2.48-2.5s2.48 1.12 2.48 2.5zm.02 4.5h-5v16h5v-16zm7.982 0h-4.968v16h4.969v-8.399c0-4.67 6.029-5.052 6.029 0v8.399h4.988v-10.131c0-7.88-8.922-7.593-11.018-3.714v-2.155z"
            />
          </svg>
        </a>
      </div>
    </div>
  </footer>
);
